import * as React from 'react';
import { FormField } from '@cian/ui-kit';
import { INPUT_PHONE_MASK } from '../../../constants/phone';
import { PhoneInput } from '../../PhoneInput';
import { jsx as _jsx } from "react/jsx-runtime";
export var PhoneField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
    error = _ref.error,
    label = _ref.label,
    onChange = _ref.onChange,
    value = _ref.value;
  return /*#__PURE__*/_jsx(FormField, {
    label: label,
    errorMessage: error,
    withoutMargin: true,
    children: /*#__PURE__*/_jsx(PhoneInput, {
      mask: INPUT_PHONE_MASK,
      inputRef: ref,
      onChange: onChange,
      value: value,
      disabled: disabled,
      invalid: !!error
    })
  });
});
PhoneField.displayName = 'PhoneField';